webpackJsonp([4,2],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(14);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routeConfig = __webpack_require__(3);
	
	var _routeConfig2 = _interopRequireDefault(_routeConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  hashbang: true,
	  history: false,
	  saveScrollPosition: true,
	  transitionOnLoad: true
	});
	
	(0, _routeConfig2.default)(router);
	
	var App = _vue2.default.extend();
	
	router.start(App, 'body');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (router) {
	  router.map({
	    '/': {
	      name: 'home',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(12)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    },
	    '/waterfall': {
	      name: 'register',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(13)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }
	  });
	};

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.58a620029895f1c3a0ef.js
 **/